import React, { useState } from "react";
import { Card, Container, CardBody, CardSubtitle, CardTitle, CardText, Button, ModalBody, Modal } from "reactstrap";
import { DataGrid } from '@mui/x-data-grid';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import { Autocomplete, Checkbox } from "@mui/material";
import { TextField } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/system';
import { StorePageHeaderName } from "../../../store/pageHeader/action";
import { useDispatch } from "react-redux";

const blue = {
    100: '#DAECFF',
    200: '#b6daff',
    400: '#3399FF',
    500: '#007FFF',
    600: '#0072E5',
    900: '#003A75',
};

const grey = {
    50: '#F3F6F9',
    100: '#E5EAF2',
    200: '#DAE2ED',
    300: '#C7D0DD',
    400: '#B0B8C4',
    500: '#9DA8B7',
    600: '#6B7A90',
    700: '#434D5B',
    800: '#303740',
    900: '#1C2025',
};

const InputElement = styled('input')(
    ({ theme }) => `
    width: 120px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    padding: 8px 12px;
    border-radius: 4px;
    color: ${theme.palette.mode === 'dark' ? grey[300] : grey[900]};
    background: ${theme.palette.mode === 'dark' ? grey[900] : '#fff'};
    border: 1px solid ${theme.palette.mode === 'dark' ? grey[700] : grey[200]};
    box-shadow: 0px 2px 4px ${theme.palette.mode === 'dark' ? 'rgba(0,0,0, 0.5)' : 'rgba(0,0,0, 0.05)'
        };
  
    &:hover {
      border-color: ${blue[400]};
    }
  
    &:focus {
      border-color: ${blue[400]};
      box-shadow: 0 0 0 3px ${theme.palette.mode === 'dark' ? blue[600] : blue[200]};
    }
  
    // firefox
    &:focus-visible {
      outline: 0;
    }
  `,
);
const AllInvoices = () => {
    document.title = "Invoice";

    const dispatch = useDispatch();
    dispatch(StorePageHeaderName('Invoice'))

    const productList = [
        { label: 'PO123844' },
        { label: 'PO654344' },
        { label: 'PO128448' },
        { label: 'PO342344' },
        { label: 'PO652344' },]

    const top100Films = [
        { label: '30% 30 Days' },
        { label: '30% 60 Days' },
        { label: 'No  60 Days' },
        { label: '30% 45 Days' },
        { label: '30% 15 Days' },]

    const columns = [
        {
            field: 'Sl_No', headerName: 'SL No.',
            // width: 100,
            sortable: false,
            resizable: false,
            flex: .5,
        },
        {
            field: 'item_Name',
            headerName: 'Item Name',
            headerClassName: 'break-header',
            cellClassName: 'product_name_wrap',
            // width: 160,
            flex: 1,
            sortable: false,
            resizable: false,
            renderCell: (params) => {
                const productName = params.value;
                return (
                    <div style={{ cursor: 'pointer' }}>
                        {productName}
                    </div>
                );
            },
        },
        {
            field: 'quantity',
            headerName: 'Quantity',
            headerClassName: 'table-header-background',
            sortable: false,
            headerAlign: 'center',
            cellClassName: 'center-aligndata',
            flex: 0.5,
            //   width: 160,
        },
        {
            field: 'Unit_price',
            headerName: 'Unit Price',
            sortable: false,
            resizable: false,
            flex: .7,
            // width: 160,
        },
        {
            field: 'amount',
            headerName: 'Amount',
            sortable: false,
            resizable: false,
            flex: .7,
            // width: 160,
        },

    ];

    const approvalrows = [
        { id: 1, Sl_No: 1, item_Name: 'HOBS HB-MARICA', quantity: 2, Unit_price: 20, amount: 160000},
        { id: 2, Sl_No: 2,item_Name: 'HOBS HB-MARICA', quantity: 2, Unit_price: 20, amount: 160000 },
    ];
    const [inputValue, setInputValue] = useState('');
    const [selectedValue, setSelectedValue] = useState(null);

    

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <div>
                        <div className='mb-3' style={{ fontSize: '20px', fontWeight: '500' }}>
                            {/* <span className='me-2' onClick={handleNavigate}><ArrowBackIcon /></span> */}
                            <span className="requisition_text">All Invoices</span>
                        </div>
                            <Box sx={{ height: 300, width: '100%', marginBottom: '30px', marginTop: '10px' }}>
                                <DataGrid
                                    className="table_header_background"
                                    headerClassName="custom-header-cell"
                                    getRowHeight={() => 'auto'}
                                    rows={approvalrows}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 5,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    disableRowSelectionOnClick
                                    disableColumnMenu
                                    disableColumnResize={true}
                                    componentsProps={{
                                        cell: {
                                            disableClick: true,
                                        },
                                    }}
                                    sx={{
                                        '& .MuiDataGrid-cell': {
                                            '& .MuiDataGrid-cell--textOverflow': {
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            },
                                        },
                                    }}
                                />
                            </Box>
                        </div>
                </Container>
            </div>
        </React.Fragment>
    );
};

export default AllInvoices;
